"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformToClientCurrencyISOPrice = exports.transformToClientCurrencyPrice = exports.transformToClientCurrencyPriceAmount = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const transformCurrencyToCurrencyISO_1 = require("./transformCurrencyToCurrencyISO");
const transformCurrencyToString_1 = require("./transformCurrencyToString");
const transformToClientCurrencyPriceAmount = (amount, currencyRate = 1) => {
    const result = amount * currencyRate;
    return Math.round(result);
};
exports.transformToClientCurrencyPriceAmount = transformToClientCurrencyPriceAmount;
const transformToClientCurrencyPrice = (amount, currency = legacy_enums_1.Currency.Euro, currencyRate = 1) => {
    if (isNaN(Number(amount))) {
        return "";
    }
    return `${(0, transformCurrencyToString_1.transformCurrencyToString)(currency)}${(0, exports.transformToClientCurrencyPriceAmount)(amount, currencyRate)}`;
};
exports.transformToClientCurrencyPrice = transformToClientCurrencyPrice;
const transformToClientCurrencyISOPrice = (amount, currency = legacy_enums_1.Currency.Euro, currencyRate = 1) => {
    if (isNaN(Number(amount))) {
        return "";
    }
    return `${(0, transformCurrencyToCurrencyISO_1.transformCurrencyToCurrencyISO)(currency)} ${(0, exports.transformToClientCurrencyPriceAmount)(amount, currencyRate)}`;
};
exports.transformToClientCurrencyISOPrice = transformToClientCurrencyISOPrice;
//# sourceMappingURL=transformToClientCurrencyPrice.js.map